var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.313 18.395v-8.21h2.895l.434-3.2H7.313V4.942c0-.927.27-1.558 1.666-1.558l1.78-.001V.521A25.002 25.002 0 0 0 8.165.395c-2.566 0-4.322 1.491-4.322 4.23v2.36H.94v3.2h2.903v8.21h3.47Z",
    fill: "#fff"
  })));
};

export default SvgSocialFacebook;